class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.setHeaderHeight();

    // Set up resize observer for header height changes
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    // Skip scroll-based show/hide for always-sticky headers
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
      document.body.classList.add('has-sticky-header');
      return;
    }

    // Make header always sticky (but still allow hide/show on scroll)
    this.header.classList.add('shopify-section-header-sticky');
    document.body.classList.add('has-sticky-header');

    // Initialize scroll tracking
    this.lastScrollTop = 0;
    this.scrollThreshold = 5; // Ignore movements smaller than 5px
    this.headerHeight = this.header.offsetHeight;

    // Bind scroll handler
    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });

    // Initialize visibility state
    this.initializeState();
  }

  setHeaderHeight() {
    const height = this.header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${height}px`);
    this.headerHeight = height;
  }

  initializeState() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop <= this.headerHeight) {
      this.header.classList.add('sticky-header--visible');
    } else {
      this.header.classList.add('sticky-header--visible');
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Ignore iOS bounce scroll
    if (currentScrollTop < 0) return;

    const scrollDelta = currentScrollTop - this.lastScrollTop;

    // Ignore small movements
    if (Math.abs(scrollDelta) < this.scrollThreshold) return;

    // Always show header at the very top of the page
    if (currentScrollTop <= this.headerHeight) {
      this.showHeader();
    } else {
      if (scrollDelta > 0) {
        this.hideHeader();
      } else {
        this.showHeader();
      }
    }

    this.lastScrollTop = currentScrollTop;
  }

  hideHeader() {
    this.header.classList.add('sticky-header--hidden');
    this.header.classList.remove('sticky-header--visible');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  showHeader() {
    this.header.classList.add('sticky-header--visible');
    this.header.classList.remove('sticky-header--hidden');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal) this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);
